<mh-notification-settings [notificationsSettings]="notificationsSettings"></mh-notification-settings>
